import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

import {
  VARIANT_FONT_SIZE,
  VARIANT_LINE_HEIGHT,
  VARIANT_WEIGHT,
  WEIGHT_VALUE,
} from './Text.constants';
import { TTextProps } from './Text.types';

export const StyledText = styled.span.withConfig({ shouldForwardProp })<TTextProps>`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme, variant = 'body' }) => theme.fontSizes[VARIANT_FONT_SIZE[variant]]}px;
  font-weight: ${({ variant = 'body', weight }) => WEIGHT_VALUE[weight ?? VARIANT_WEIGHT[variant]]};
  color: ${({ theme, color = 'textPrimary' }) => theme.colors[color]};
  text-align: ${({ align = 'left' }) => align};
  line-height: ${({ variant = 'body' }) => VARIANT_LINE_HEIGHT[variant]};

  ${({ ellipsis }) =>
    ellipsis &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;
